import { render, staticRenderFns } from "./HisDateTimeItemComponent.vue?vue&type=template&id=227e6aa4&scoped=true&"
import script from "./HisDateTimeItemComponent.vue?vue&type=script&lang=ts&"
export * from "./HisDateTimeItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e6aa4",
  null
  
)

export default component.exports